import {
  CategoryServiceClient
} from "@/proto/category_grpc_web_pb";
import { 
  Category, 
  ListCategoryRequest,
  ItemCategoryRequest,
  CategoryFilter,
  CategorySort,
  CategoryPagination,
  CreateCategoryRequest,  
  UpdateCategoryRequest, 
  DeleteCategoryRequest
} from "@/proto/category_pb";
import {handleRefreshToken} from '@/main'

// Количество на странице по-умолчанию
const defaultLimit:number = 100;

export class CategoryApi {
  items: Array<Category> = [];
  client: CategoryServiceClient;

  constructor() {
    const host:string = (window as any).VUE_APP_API_URL ?? '';
    this.client = new CategoryServiceClient(host, null, null);
  }

  getAuth(){
    const metadata: any = {
      Authorization: localStorage.getItem('accessToken')
    }
    return metadata
  }

  // Установка и получение фильтров
  createFilter(data: any){
    
    const filter = new CategoryFilter();
    const categoryId:number = data.categoryId !== undefined ? parseInt(data.categoryId) : 0;
    const categoryName:string = data.categoryName !== undefined ? data.categoryName.toString() : "";

    // Устанавливаем фильтры
    filter.setCategoryId(categoryId);
    filter.setCategoryName(categoryName);

    return filter;
  }

  // Установка и получение сортировки
  createSort(data: any){

    const sort = new CategorySort();
    const name:string = data.name !== undefined ? data.name.toString() : "category_name";
    const exp:string = data.exp !== undefined ? data.exp.toString() : "asc";

    // Устанавливаем параметры сортировки
    sort.setName(name);
    sort.setExp(exp);

    return sort;
  }

  // Установка и получение пагинации
  createPagination(data: any){

    const pagination = new CategoryPagination();
    const page:number = data.page !== undefined ? Number(data.page) : 1;
    const limit:number = data.limit !== undefined ? Number(data.limit) : defaultLimit;

    // Устанавливаем пагинацию
    pagination.setPage(page);
    pagination.setLimit(limit);
    pagination.setPages(0);

    return pagination;
  }

  // Список элементов
  getCategoryItems(filter: any, sort: any, pagination: any){

    const request = new ListCategoryRequest();

    // Устанавливаем параметры запроса
    request.setFilter(this.createFilter(filter));
    request.setSort(this.createSort(sort));
    request.setPagination(this.createPagination(pagination));

    return new Promise((resolve, reject) => {
      this.client.listCategory(request, this.getAuth(), (err, message) => {
        if (err) {
          handleRefreshToken()
          reject(err)
        } else {
          resolve(message.getItemsList());
        }
      });
    });
  }

  // Получение элемента
  getCategoryItem(filter: any){

    const request = new ItemCategoryRequest();

    // Устанавливаем параметры запроса
    request.setFilter(this.createFilter(filter));

    return new Promise((resolve, reject) => {
      this.client.itemCategory(request, this.getAuth(), (err, message) => {
        if (err) {
          handleRefreshToken()
          reject(err)
        } else {
          resolve(message.getItem());
        }
      });
    });
  }

  // Создание элемента
  createCategoryItem(data: any){

    const request = new CreateCategoryRequest();
    request.setCategoryId(data.categoryId);
    request.setCategoryName(data.categoryName);

    return new Promise((resolve, reject) => {
      this.client.createCategory(request, this.getAuth(), (err, message) => {
        if (err) {
          handleRefreshToken()
          reject(err)
        } else {
          resolve(message);
        }
      });
    });
  }

  // Редактирование элемента
  updateCategoryItem(data: any){

    const request = new UpdateCategoryRequest();
    request.setCategoryId(data.categoryId);
    request.setCategoryName(data.categoryName);

    return new Promise((resolve, reject) => {
      this.client.updateCategory(request, this.getAuth(), (err, message) => {
        if (err) {
          handleRefreshToken()
          reject(err);
        } else {
          resolve(message);
        }
      });
    });
  }

  // Удаление элемента
  deleteCategoryItem(data: any){

    const request = new DeleteCategoryRequest();
    request.setCategoryId(data.categoryId);

    return new Promise((resolve, reject) => {
      this.client.deleteCategory(request, this.getAuth(), (err, message) => {
        if (err) {
          handleRefreshToken()
          reject(err);
        } else {
          resolve(message);
        }
      });
    });
  }
}